import type { RenderContext, RenderField } from "../types.ts";
import { renderTextLikeField } from "./text-input.ts";

export const renderEmailField = (
  field: RenderField<"EMAIL">,
  context: RenderContext,
): HTMLElement => {
  return renderTextLikeField(field, context, "email");
};
